import React, {Component} from 'react'


export default class PeaceFocus extends Component {

    constructor() {
        super()
        this.state = {
            clock : 0
        }
    }

    componentDidMount() {
        this.clockFx()
    }

    componentWillUnmount() {
        clearInterval(this.clockFx)
    }

    clockFx = () => {

        setInterval(() => {
            this.setState(
                { clock : this.state.clock + 1}
            )
        }, 1000)
    }


    render() {

        const WrapperStyle = {
            backgroundImage : 'url("/focus.jpg")',
            minHeight : '100vh',
            backgroundPosition : 'center',
            backgroundRepeat : 'no-repeat',
            backgroundSize : 'cover',
            backgroundAttachment : 'fixed'
        }


        return (

            <div id='PeaceFocus' style={WrapperStyle}>

                <div className='PeaceClock'>
                    <h5 style={{color: '#FFFFFF'}}>TIME : {this.state.clock}</h5>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/peace/PeaceFocus.js